import { Centro, PilaV } from '@/components/atomos';
import { Heading } from '@chakra-ui/react';

import Recaptcha from './Recaptcha';
import { FC } from 'react';
import { Bot } from 'lucide-react';

const PantallaVerificacion: FC<ReCaptchaV2.Parameters> = (params) => {
  return (
    <Centro h={'100dvh'} w={'full'} flexDirection={'column'} gap={2}>
      <PilaV spacing={0}>
        <Bot size={120} strokeWidth={1.5} color='var(--bPink-400)'/>
        <Heading
          size={'md'}
          color={'foreground-secondary'}
          fontWeight={'semibold'}
          lineHeight={"short"}
        >
          Verifica que eres humano:
        </Heading>
      </PilaV>
      <Recaptcha {...params} />
    </Centro>
  );
};

export default PantallaVerificacion;
